import React from 'react';
import CryptoIcon from '../CryptoIcon/CryptoIcon';

interface CryptoIconPairProps {
    baseTicker: string;
    quoteTicker: string;
    variant: 'horizontal' | 'diagonal';
}

const CryptoIconPair: React.FC<CryptoIconPairProps> = ({ baseTicker = '', quoteTicker = '', variant }) => {
    const iconSize = variant === 'horizontal' ? 22 : 21;
    const style = {
        position: 'relative',
        display: 'inline-block',
        zIndex: 1,
    } as any;

    if (variant === 'horizontal') {
        style.width = '34px';
    } else {
        style.width = '30px';
        style.height = '30px';
    }

    const baseStyle = {
        zIndex: 2,
        position: 'relative'
    } as any;

    const quoteStyle = variant === 'horizontal'
        ? {
            position: 'absolute',
            left: '10px',
            top: '0'
        }
        : {
            position: 'absolute',
            top: '7px',
            left: '7px',
        } as any;

    return (
        <div style={style}>
            <div style={baseStyle}>
                <CryptoIcon ticker={baseTicker} size={iconSize} />
            </div>
            <div style={quoteStyle}>
                <CryptoIcon ticker={quoteTicker} size={iconSize} />
            </div>
        </div>
    );
};

export default CryptoIconPair;
